import actions from '../../../../redux/actions/ui/dataImport/strategies/productImageStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function ProductImageStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

ProductImageStrategy.title = actions.title
const option = {
  value: 'product_image',
  display: 'Update Product Image',
  category: 'products',
  Component: ProductImageStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductImageStrategy.option = option
